import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const Title = styled(Typography)({
  marginTop: 30,
  marginBottom: 20,
});

export const GuestListContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "inviteTheme",
})(({ inviteTheme }) => ({
  backgroundColor: inviteTheme?.guestListBackgroundColor,
}));

export const GuestList = styled(Grid)({
  marginBottom: 76,
});
